import { axiosFactory, axiosPostFactory } from "./axios-factory";
// import { axiosFactory } from './axios-factory'

export default {
  // 获取数据申请 已审核列表
  getExamineList(classifyId, appId, page, pageSize) {
    return axiosFactory({
      method: "get",
      params: {
        classifyId,
        appId,
        page,
        pageSize
      },
      url: "/exchange-openplatform/backend/appExamine/authorized.do"
    });
  },
  // 获取数据申请 未审核列表
  getUnExamineList(appId, page, pageSize) {
    return axiosFactory({
      method: "get",
      params: {
        appId,
        page,
        pageSize
      },
      url: "/exchange-openplatform/backend/appExamine/unauthorized.do"
    });
  },
  // 获取字段列表
  getfieldList(appId, objectId, auditStatus) {
    return axiosFactory({
      method: "get",
      params: {
        appId,
        objectId,
        auditStatus
      },
      url: "/exchange-openplatform/backend/appExamine/authFieldList.do"
    });
  },
  // 获取数据互操作管理分类下拉菜单
  getOptionList() {
    return axiosFactory({
      method: "get",
      url: "/exchange-openplatform/backend/appExamine/selectOption.do"
    });
  },
  // 获取申请树对象列表（二级）
  getSecondTreeList(classifyId) {
    return axiosFactory({
      method: "get",
      params: {
        classifyId
      },
      url: "/exchange-openplatform/backend/appExamine/treeObjectList.do"
    });
  },
  // 获取申请树的字段列表(三级)
  getThirdTreeList(objectId) {
    return axiosFactory({
      method: "get",
      params: {
        objectId
      },
      url: "/exchange-openplatform/backend/appExamine/authApplyFieldList.do"
    });
  },
  // 设置数据管理添加对象列表
  setApplyList(appId, url, applyList) {
    return axiosPostFactory({
      method: "post",
      cType: "application/json",
      data: {
        appId,
        url,
        applyList
      },
      url: "/exchange-openplatform/backend/appExamine/saveApplyList.do"
    });
  },
  // 发送权限请求
  getCheckAuth(initUrl, ignore) {
    return axiosFactory({
      method: "get",
      params: {
        initUrl
      },
      ignore,
      url: "/exchange-openplatform/backend/appExamine/checkAuth.do"
    });
  },
  // 403的时候发送请求
  getRedirect(initUrl) {
    return axiosFactory({
      method: "get",
      params: {
        initUrl
      },
      url: "/exchange-openplatform/backend/casClient/index"
    });
  },
  // 获取数据互操作地址
  getUrl() {
    return axiosFactory({
      method: "get",
      url: "/exchange-openplatform/backend/appExamine/getConfig.do"
    });
  },
  // 根据平台类型获取平台logo配置
  getLogoConfigVoByPlatform() {
    return axiosFactory({
      method: "post",
      params: { platformType: 1 },
      url: "/openplatformManage/backend/logoConfig/getLogoConfigVoByPlatform"
    });
  }
};



// WEBPACK FOOTER //
// ./src/pages/exchangeDataManage/services/common.js